import { createContext } from 'react'
import { Session } from '../model'
import { AppContextData } from './AppContext.types'

export const AppContext = createContext<AppContextData>({
    session: undefined,
    setSession: (session: Session) => {},
    removeSession: () => {},
    onSignedIn: () => {},
    onChangedTenant: (tenantId: string) => {},
    isGranted: (action: string) => {
        return false
    },
    isGrantedAny: (actions: string[]) => {
        return false
    },
})
